import React from "react";
import { ReactSVG } from "react-svg";
import "./FooterInfo.scss";
import logo from "@images/impressit-logo.svg";
import facebookIcon from "@images/ic-facebook.svg";
import instagramIcon from "@images/ic-inst.svg";
import twitterIcon from "@images/ic-twitter.svg";
import linkedinIcon from "@images/ic-linkedin.svg";
import useWindowDimensions from "@hooks/useWindowDimensions";
import { TABLET_MIN_WIDTH } from "@constants";

const FooterInfo = () => {
    const socialMediaInfo = [
        {
            icon: facebookIcon,
            link: "https://www.facebook.com/impressit.io/",
        },
        {
            icon: instagramIcon,
            link: "https://www.instagram.com/impressit_team/",
        },
        {
            icon: twitterIcon,
            link: "https://twitter.com/impressit_team",
        },
        {
            icon: linkedinIcon,
            link: "https://www.linkedin.com/company/impressit/",
        },
    ];

    const { width } = useWindowDimensions();
    const isMobile = width < TABLET_MIN_WIDTH;

    return (
        <div className="footer-info">
            <div className="footer-info-container">
                <div className="footer-info-logo-container">
                    <ReactSVG
                        src={logo}
                        className="footer-info-logo"
                        alt="impressit logo"
                    />
                    impressit
                </div>
                <span className="footer-info-copyright">
                    Copyright © 2018-2022 Impressit.
                    {isMobile && <br />}&nbsp; All rights reserved.
                </span>
            </div>
            <div className="footer-info-links-container">
                {socialMediaInfo.map((info, index) => (
                    <a
                        target="_blank"
                        className="footer-info-link"
                        href={info.link}
                        key={index}
                        rel="noreferrer"
                    >
                        <ReactSVG
                            src={info.icon}
                            className="footer-info-link-icon"
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default FooterInfo;
